import numberUtils from '@/utils/number';

const tableDataConverter = (table: ChartTableRes, type: ChartTableType) => {
  if (type === 'single') {
    const singleTable = table as ChartSingleTableRes;
    return {
      ...singleTable,
      tables: singleTable.tables.map((tableItem) =>
        tableItem.map((item) => ({
          ...item,
          value: numberUtils.formatDecimal(item.value, 1),
        })),
      ),
      compare_tables: singleTable.compare_tables?.map((tableItem) =>
        tableItem.map((item) => ({
          ...item,
          value: numberUtils.formatDecimal(item.value, 1),
        })),
      ),
    };
  }

  if (type === 'cross') {
    const crossTable = table as ChartCrossTableRes;
    return {
      ...crossTable,
      tables: crossTable.tables.map((tableItem) =>
        tableItem.map((item) => ({
          ...item,
          values: item.values.map((y) => {
            return {
              ...y,
              value: numberUtils.formatDecimal(y.value, 1),
            };
          }),
        })),
      ),
      compare_tables: crossTable.compare_tables?.map((tableItem) =>
        tableItem.map((item) => ({
          ...item,
          values: item.values.map((y) => {
            return {
              ...y,
              value: numberUtils.formatDecimal(y.value, 1),
            };
          }),
        })),
      ),
    };
  }
};

export { tableDataConverter };
